/* Importing Angular Core */
import { Injectable, NgZone } from "@angular/core";
import { Subject } from "rxjs";

const MamCollapsed = new Subject();
const LiveStatusDidChange = new Subject();

@Injectable()
export class UI {
  EVENTS = {
    ShowAlert: "evrideo.showAlert",
    UploadDone: "evrideo.uploadDone",
    LibraryFilterToggle: "evrideo.libraryFilterToggle",
    ShowConfirm: "evrideo.ShowConfirm",
    ChangePlayingItem: "ChangePlayingItem",
    LicensingIssue: "LicensingIssue",
    AlertDismissed: "evrideo.AlertDismissed",
    OpenVideoPreview: "evrideo.openVideoPreview",
    OpenEditMedia: "evrideo.openEditMode",
    CloseVideoPreview: "evrideo.closeViewPreview",
    DismissUploaderItem: "evrideo.dismissUploaderItem",
    CloseTopMenu: "evrideo.closeTopMenu",
    MamCollapsed: MamCollapsed,
    LiveStatusDidChange: LiveStatusDidChange,
  };
  private readonly GLOBAL_EVENTS_DATA = {
    ChangePlayingItem: {
      event: this.EVENTS.ShowConfirm,
      title: "Change Playing Item",
      message:
        "You are about to make a change that might affect the currently playing item.<br/>This action might lead to a visual alteration in an active channel.<br>Are you sure you want to continue?",
      buttons: [
        {
          approve: true,
          title: "Yes",
          callback: () => {},
        },
        {
          title: "No",
          deny: true,
          callback: () => {},
        },
      ],
    },
    LicensingIssue: {
      event: this.EVENTS.ShowAlert,
      title: "License Scheduling Issue",
      message:
        "The scheduling of this media item is not possible at the current time slot.<br/> Please check the licensing settings for the item.",
      buttons: [
        {
          approve: true,
          title: "OK",
          callback: () => {},
        },
      ],
    },
  };

  listeners = [];

  /**
   * Building up the services
   * @param zone
   */
  constructor(private zone: NgZone) {}

  /**
   * Notify about events
   * @param event
   * @param data
   * @return void
   */
  notify(eventName, data) {
    var event = new Event(eventName);
    event["data"] = data;

    window.dispatchEvent(event);
  }
  globalNotify(eventName, approveCallback, denyCallback) {
    const data = this.GLOBAL_EVENTS_DATA[eventName];
    if (data) {
      if (approveCallback) {
        data.buttons.filter((x) => x.approve)[0].callback = approveCallback;
      }
      if (denyCallback) {
        data.buttons.filter((x) => x.deny)[0].callback = denyCallback;
      }
      this.notify(data.event || eventName, data);
    }
  }

  /**
   * Listening to an event
   * @param event
   * @return void
   */
  listen(event, callback) {
    const func = this.getCallback(callback);

    /* Listening to event */
    window.addEventListener(event, callback, false);
  }

  cleanUpListeners(event) {
    window.removeEventListener(event, this.listeners[event], false);
  }

  /**
   * Removing the callback according to event
   * @param event
   * @param callback
   * @return void
   */
  removeListener(event, callback) {
    window.removeEventListener(event, this.getCallback(callback), false);
  }

  /**
   * Return Computed Style for Element
   * @param element
   * @return mixed
   */
  getComputedElement(element, key) {
    return window.getComputedStyle(element)[key];
  }

  /**
   * Assign Css Properties to element
   * @param element
   * @param rules
   * @return element
   */
  setCssProperty(element, rules = {}) {
    for (const rule in rules) {
      element.style[rule] = rules[rule];
    }

    return element;
  }

  getCallback(callback) {
    const $this = this;

    return function (event) {
      if (typeof callback == "function") callback(event["data"]);
    };
  }
}
